module.exports = __webpack_public_path__ + "media/images/plan-detail__image-1@2x-c2efcd7fad9d55077843a13bfb9cb85e.jpg";